module.exports = __webpack_public_path__ + "media/images/apple_health/watch/rowhouse-b8f9e303779d19c23d29ad6d142f7a76.svg";